/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import {
  CommandResult_ContractPumpType,
  ListCommandResult_ContractPumpType
} from "@graphql/helpers/types.graphql";
import {
  CommandResult,
  ListCommandResult
} from "@graphql/groups/fragment.graphql";
import utils, {
  TContractPumpTypeType,
  TNonEmptyArray,
  TJoin,
  TContractType
} from "@graphql/helpers/utils.graphql";

type TGlobal =
  | TContractPumpTypeType
  | TJoin<"contract", TContractType>;

type TContractPumpTypeByIdFunctions = {
  getByID: CommandResult_ContractPumpType;
};
export type TContractPumpTypeByIdQueries = {
  contractPumpType: TContractPumpTypeByIdFunctions;
};

export const contractPumpTypeById = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query contractPumpTypeById($id: Guid!) {
    contractPumpType {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_ContractPumpType")}
`;

type TContractPumpTypeAllWithPaginationFunctions = {
  getAllWithPagination: ListCommandResult_ContractPumpType;
};
export type TContractPumpTypeAllWithPaginationQueries = {
  contractPumpType: TContractPumpTypeAllWithPaginationFunctions;
};
export const contractPumpTypeAllWithPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query contractPumpTypeAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    contractPumpType {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_ContractPumpType")}
`;
